import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowsAllSides: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrows-all-sides, move, focus"><path d="M9 6L12 3L15 6M6 9L3 12L6 15M18 9L21 12L18 15M15 18L12 21L9 18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconArrowsAllSides;
